/**
 * Created by user on 2018/4/16/016.
 */

import getDefaultModList from './mod';
import { Segment } from './Segment';
import { useDefault } from './defaults';

export { getDefaultModList }

export { Segment }

export { useDefault }

export default Segment;
